import {endOfDay, isValid, parseISO} from 'date-fns';
import {Pattern, match} from 'ts-pattern';

import {isNotNil} from 'ramda';

import type {TaskResponseBody} from '@dms/api/core';

import type {BusinessCasePlannedActivity} from '@prompt-bridge/shared/ai-assistant-core';

const toDateOnlyTaskDueAt = (dueDate: string | null) =>
  match(dueDate)
    .returnType<string | null>()
    .with(Pattern.nullish, () => null)
    .otherwise((date) => {
      const parsedDate = parseISO(date);
      return isValid(parsedDate) ? endOfDay(parsedDate).toISOString() : null;
    });

export const toTaskBusinessCasePlannedActivity = (
  task: TaskResponseBody
): BusinessCasePlannedActivity => ({
  id: task.id,
  kind: 'task',
  dueAt: task.dueTo ?? task.dueFrom ?? toDateOnlyTaskDueAt(task.dueDate),
  completed: task.state === 'DONE' || isNotNil(task.finishedAt),
});
